import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
  DataTableServerQuery,
} from '@/components/data-table-builder/data-table.types';

interface ISeuilDataTableProps {
  store: any;
  createAction?: () => void;
  rowActions?: any;
  serverQuery?: DataTableServerQuery;
}

export const getSeuilDataTableStructure = ({ store, createAction, rowActions, serverQuery }: ISeuilDataTableProps): DynamicDataTable => {
  const typeMarcheColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.seuils.table.typeMarche',
    accessorKey: 'typeMarcher.description',
    variant: DataTableColumnVariant.TEXT,
  };

  const montantColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.seuils.table.seuil',
    accessorKey: 'montant',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'settings.seuils.table.singular',
    plural: 'settings.seuils.table.plural',
    columns: [typeMarcheColumn, montantColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    enableServerActions: true,
    serverQuery,
    disablePagination: false,
    stripedRows: true,
    target: row => {
      store.set('response', row);
      store.set('dto', {
        typeMarcherId: row.typeMarcher?.id ?? row.typeMarcherId,
        montant: row.montant,
      });
    },
    createAction,
    rowActions,
    searchableFields: ['typeMarcher.description', 'montant'],
  };
};
